export default "__VITE_ASSET__HXFuQ2La__"